import { create } from "zustand";
import { persist } from "zustand/middleware";

type LikesState = {
  liked: Record<string, true>;
  setLiked: (productId: string, liked: boolean) => void;
};

export const useLikesStore = create<LikesState>()(
  persist(
    (set) => ({
      liked: {},
      setLiked: (productId, liked) =>
        set((state) => {
          const next = { ...state.liked };
          if (liked) {
            next[productId] = true;
          } else {
            delete next[productId];
          }
          return { liked: next };
        })
    }),
    { name: "revlane-liked-products" }
  )
);
